import React from "react";
import SecondaryButton from "../../../../components/buttons/secondary-button";
import styles from "../index.module.scss";

const AddProviderButton = ({ onClick, disabled }) => (
	<SecondaryButton
		text="+ Add Another Provider"
		fontType="regular"
		fullWidth
		onClick={onClick}
		disabled={disabled}
		extraClass={styles.addProviderButton}
		extraTextClass={styles.addProviderText}
	/>
);

export default AddProviderButton;
